import { createMuiTheme } from "@material-ui/core/styles";

export const colorTokens = {
  colors: {
    "text.primary": {
      default: "#000",
      dark: "#fff",
    },
    "text.secondary": {
      default: "#fff",
      dark: "#000",
    },
    "text.tertiary": {
      default: "#5C5C5C",
      dark: "#D6D6D6",
    },
    "text.highlight": {
      default: "#0987A0",
    },
    "text.warning": {
      default: "#E53E3E",
    },
    "icon.primary": {
      default: "#000",
      dark: "#fff",
    },
    "icon.secondary": {
      default: "#fff",
      dark: "#000",
    },
    "border.primary": {
      default: "#000",
      dark: "#fff",
    },
    "border.secondary": {
      default: "#A3A3A3",
      dark: "#A3A3A3",
    },
    "border.tertiary": {
      default: "#00000014",
      dark: "#A3A3A3",
    },
    "action.primary": {
      default: "#000",
      dark: "#fff",
    },
    "action.secondary": {
      default: "#fff",
      dark: "inherit",
    },
    "action.tertiary": {
      default: "#f4f4f4",
      dark: "#000",
    },
  },
};

export const theme = createMuiTheme({
  palette: {
    light: {
      text: {
        primary: colorTokens.colors["text.primary"].default,
        secondary: colorTokens.colors["text.secondary"].default,
        tertiary: colorTokens.colors["text.tertiary"].default,
        highlight: colorTokens.colors["text.highlight"].default,
        warning: colorTokens.colors["text.warning"].default,
      },
      icon: {
        primary: colorTokens.colors["icon.primary"].default,
        secondary: colorTokens.colors["icon.secondary"].default,
      },
      border: {
        primary: colorTokens.colors["border.primary"].default,
        secondary: colorTokens.colors["border.secondary"].default,
        tertiary: colorTokens.colors["border.tertiary"].default,
      },
      action: {
        primary: colorTokens.colors["action.primary"].default,
        secondary: colorTokens.colors["action.secondary"].default,
        tertiary: colorTokens.colors["action.tertiary"].default,
      },
    },
    dark: {
      text: {
        primary: colorTokens.colors["text.primary"].dark,
        secondary: colorTokens.colors["text.secondary"].dark,
        tertiary: colorTokens.colors["text.tertiary"].dark,
      },
      icon: {
        primary: colorTokens.colors["icon.primary"].dark,
        secondary: colorTokens.colors["icon.secondary"].dark,
      },
      border: {
        primary: colorTokens.colors["border.primary"].dark,
        secondary: colorTokens.colors["border.secondary"].dark,
        tertiary: colorTokens.colors["border.tertiary"].dark,
      },
      action: {
        primary: colorTokens.colors["action.primary"].dark,
        secondary: colorTokens.colors["action.secondary"].dark,
        tertiary: colorTokens.colors["action.tertiary"].dark,
      },
    },
  },
});
